import React, { PropTypes as p } from 'react'
import Measure from 'react-measure'

import PinPositioner from './pin-positioner'
import PinMarker from './pin-marker'
import PinCushion from './pin-cushion'

const PinMap = React.createClass({
  propTypes: {
    pins: p.array.isRequired,
    imageUrl: p.string.isRequired,
    activePinId: p.number.isRequired,
    onPinPlace: p.func,
    onPinClick: p.func,
    onPinMouseOver: p.func,
    onPinMouseOut: p.func
  },

  getInitialState () {
    return {
      imageLoaded: false,
      mapMeasured: false
    }
  },

  componentDidMount () {
    if (this.refs.image.complete) {
      this.setImageDimensions()
    } else {
      this.refs.image.onload = () => this.setImageDimensions()
    }
  },

  setComponentMeasurements (measurements) {
    this.setState({
      componentMeasurements: measurements
    })
  },

  setImageDimensions () {
    const { width, height } = this.refs.image

    this.setState({
      imageLoaded: true,
      imageActualWidth: width,
      imageActualHeight: height
    })
  },

  setMapDimensions ({ width, height }) {
    this.setState({
      mapMeasured: true,
      mapWidth: width,
      mapHeight: height
    })
  },

  getCurrentImageDimensions () {
    if (this.imageAspectRatio() > this.componentAspectRatio()) {
      return {
        width: this.state.mapWidth,
        height: this.state.mapWidth / this.imageAspectRatio()
      }
    } else {
      return {
        width: this.state.mapHeight * this.imageAspectRatio(),
        height: this.state.mapHeight
      }
    }
  },

  getCurrentImagePosition () {
    const { width, height } = this.getCurrentImageDimensions()

    if (this.imageAspectRatio() > this.componentAspectRatio()) {
      return {
        top: (this.state.mapHeight - height) / 2 + 'px'
      }
    } else {
      return {
        left: (this.state.mapWidth - width) / 2 + 'px'
      }
    }
  },

  getCurrentImageStyle () {
    if (!this.state.imageLoaded || !this.state.mapMeasured) return { visibility: 'hidden' }

    return {
      ...this.getCurrentImageDimensions(),
      ...this.getCurrentImagePosition()
    }
  },

  imageAspectRatio () {
    return this.state.imageActualWidth / this.state.imageActualHeight
  },

  handlePinPlace (...args) {
    if (this.props.activePinId < 0) {
      this.props.onPinPlace(...args)
    }
  },

  componentAspectRatio () {
    return this.state.mapWidth / this.state.mapHeight
  },

  render () {
    const {
      pins,
      imageUrl,
      activePinId,
      onPinClick,
      onPinMouseOver,
      onPinMouseOut
    } = this.props

    return (
      <Measure onMeasure={this.setComponentMeasurements} whitelist={['top', 'left', 'right']}>
        <div className='pin-map'>
          <Measure whitelist={['width', 'height']} onMeasure={this.setMapDimensions}>
            <div className='wrapper'>
              <img src={imageUrl} ref='image' style={this.getCurrentImageStyle()} />

              {this.state.imageLoaded &&
                <PinCushion
                  onPinPlace={this.handlePinPlace}
                  style={this.getCurrentImageStyle()}
                >
                  {pins.map(pin =>
                    <PinPositioner
                      key={pin.id}
                      id={pin.id}
                      componentMeasurements={this.state.componentMeasurements}
                      mapWidth={this.getCurrentImageStyle().width}
                      active={activePinId === pin.id}
                      x={pin.x} y={pin.y}
                    >
                      {(calloutLocation) =>
                        <PinMarker
                          pin={pin}
                          withPreview={activePinId === pin.id}
                          className={calloutLocation}
                          onClick={() => onPinClick(pin.id)}
                          onMouseOver={() => onPinMouseOver(pin.id)}
                          onMouseOut={() => onPinMouseOut(pin.id)}
                        />
                      }
                    </PinPositioner>
                  )}
                </PinCushion>
              }
            </div>
          </Measure>
        </div>
      </Measure>
    )
  }
})

export default PinMap



// WEBPACK FOOTER //
// ./src/components/pins/pin-map.js